var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLikeInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A1A6AC",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M16 26.92L5.775 16.313c-2.29-2.376-2.25-6.192.09-8.517 2.332-2.32 6.07-2.28 8.355.09l1.24 1.286.54.56.54-.56 1.24-1.286c2.284-2.37 6.023-2.41 8.356-.09 2.339 2.325 2.38 6.141.089 8.517L16 26.92z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLikeInactive);
export default __webpack_public_path__ + "static/media/icon-like-inactive.d5a909e6.svg";
export { ForwardRef as ReactComponent };